
export const config = {
  isDevelopmentMode: process.env.NODE_ENV !== "production",

  baseAssetUrl: "/build/1.0"
};
